import { useEffect, useState } from 'react';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    fallbackSrc: string;
}

export const Img: React.FC<ImageWithFallbackProps> = ({ src, fallbackSrc, alt, ...props }) => {
    const [imgSrc, setImgSrc] = useState(src);
    const handleOnError = () => {
        setImgSrc(fallbackSrc);
    };

    useEffect(() => {
        setImgSrc(src);
    }, [src]);

    return <img {...props} src={imgSrc} alt={alt} onError={handleOnError} />;
};
